var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 12.8a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6Zm0-8a1.6 1.6 0 0 0-1.6 1.6.8.8 0 0 1-1.6 0A3.205 3.205 0 0 1 8 3.2a3.07 3.07 0 0 1 3.205 3.04 2.585 2.585 0 0 1-1.055 2.165l-.415.345a5.632 5.632 0 0 1-.285.23l-.125.1-.11.085a.8.8 0 0 0-.405.785.8.8 0 1 1-1.6 0 2.335 2.335 0 0 1 1-2.035c-.03.025.375-.29.5-.38l.41-.345a1.05 1.05 0 0 0 .5-.95A1.5 1.5 0 0 0 8 4.8ZM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgQuestionCircle;